import { Capacitor } from '@capacitor/core';

/**
 * Platform helpers combining Capacitor native detection and web user-agent detection.
 */

/** True when running inside the Capacitor native shell (iOS/Android app). */
export const isNativeApp = (): boolean => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

/** 'ios' | 'android' | 'web' */
export const getPlatformName = (): 'ios' | 'android' | 'web' => {
  try {
    const p = Capacitor.getPlatform();
    if (p === 'ios' || p === 'android') return p;
  } catch {
    /* noop */
  }
  return 'web';
};

/** iPhone / iPad / iPod either as native app or in a mobile browser. */
export const isIOSDevice = (): boolean => {
  if (getPlatformName() === 'ios') return true;
  const ua = navigator.userAgent || '';
  const iOSUA = /iPad|iPhone|iPod/i.test(ua);
  // iPadOS 13+ reports as Mac with touch support
  const iPadOS = /Macintosh/i.test(ua) && typeof document !== 'undefined' && 'ontouchend' in document;
  return iOSUA || iPadOS;
};

/** Android as native app or in a mobile browser. */
export const isAndroidDevice = (): boolean => {
  if (getPlatformName() === 'android') return true;
  return /Android/i.test(navigator.userAgent || '');
};

/** Any mobile device (iOS or Android). */
export const isMobileDevice = (): boolean => isIOSDevice() || isAndroidDevice();

/**
 * Whether to display the Google sign-in button.
 * Shown on desktop web and on any Android/iOS device (native or web).
 */
export const shouldShowGoogleButton = (): boolean => true;

/**
 * Whether to display the Apple sign-in button.
 * Only on iPhone / iPad / iOS (native or web).
 */
//export const shouldShowAppleButton = (): boolean => isIOSDevice();

/**
 * Que l'on soit sur iPhone/iPad OU sur le navigateur Safari d'un Mac de bureau
 */
export const shouldShowAppleButton = (): boolean => {
  // 1. Ton test iOS actuel (iPhone / iPad)
  if (isIOSDevice()) return true;

  // 2. Ajout de la détection pour Safari sur Mac de bureau
  const ua = navigator.userAgent || '';
  const isMac = /Macintosh/i.test(ua);
  const isSafari = /Safari/i.test(ua) && !/Chrome|Chromium|Edg/i.test(ua);

  return isMac && isSafari;
};